import React from 'react';

import {
	Table,
	Alert,
	Button,
	Loader
} from 'kepler';

class SearchResult extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			searchResultValues:this.props.searchResult || '',
			pageNo:this.props.pageNo || '',
			searchResultArrays: this.props.searchResult.results || '',
			loader: false
		};
		this.onCharityClick = this.onCharityClick.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		let oldData = this.state.searchResultArrays;// Array of data
		let newData = nextProps.searchResult.results;
		let combinedData = oldData.concat(newData);
		this.setState({
			searchResultArrays: combinedData
		});
   }
	onCharityClick(nonprofit_id, charity_type, email, name){
		let csrf = $('body').attr('data-csrf');
		let self = this;
		this.setState({
				loader: true
		});
		var form = $('<form />', {
        action: "/givingfund/partner/profile",
        method: "post",
        style: 'display: none;'
    });
		$('<input />', {
                type: 'hidden',
                name: "npid",
                value: nonprofit_id
            }).appendTo(form);
		$('<input />', {
                type: 'hidden',
                name: "charityType",
                value: charity_type
            }).appendTo(form);
		$('<input />', {
                type: 'hidden',
                name: "email",
                value: email
            }).appendTo(form);

		$('<input />', {
								type: 'hidden',
								name: "_csrf",
								value: csrf
						}).appendTo(form);
		$('<input />', {
								type: 'hidden',
								name: "pageNo",
								value: 1
						}).appendTo(form);
		$('<input />', {
								type: 'hidden',
								name: "charityName",
								value: name
						}).appendTo(form);
     form.appendTo('body').submit();
	}
	render() {
		var self = this;
		let results = this.state.searchResultArrays;
    let resultsList = results.map(function(result, index){
                    return <tr key={index} onClick={self.onCharityClick.bind(this, result.nonprofit_id, result.charity_type, result.email, result.name)}><td>{result.name} {result.ein && <div className="text-muted">{(result.address.country_code == 'GB') ? 'Charity Commission number:' : (result.address.country_code == 'AU') ? 'ABN:' : (result.address.country_code == 'CA') ? 'CRA number:' : 'EIN:'} {result.ein}</div>}</td><td>{result.giving_fund_status_detail}</td><td>{result.nonprofit_id}</td><td>{result.ppgfenrollmentstatus}</td><td>{result.registration_date}</td><td>{result.address.state}</td><td>{result.address.country_code}</td></tr>
                  });
		return (
			<div id="searchResult">
				<Loader show={this.state.loader} priority={10} type="fixed" size="lg" opacity={0.5}></Loader>
				<div>
				<Alert type="info" className="pull-left"><strong>Total charities found: </strong> {this.state.searchResultValues.total_items}</Alert>
				<Button type="secondary" className="pull-right" onClick={this.props.modifySearch} id="modifySearchBtn">Modify Search</Button>
				<Button type="primary" className="pull-right" onClick={this.props.startaNewSearch} id="startaSearchBtn">Start a New Search</Button>
				</div>
				<Table id="searchResultTable">
					<colgroup>
						<col width="30%" />
						<col width="10%" />
						<col width="10%" />
						<col width="15%" />
						<col width="15%" />
						<col width="15%" />
						<col width="5%" />
					</colgroup>
					<thead>
						<tr>
							<th>Name</th>
							<th>Status</th>
							<th>NPID</th>
							<th>Enrollment Status</th>
							<th>Date Added</th>
							<th>State</th>
							<th>Country</th>
						</tr>
					</thead>
					<tbody>
						{ resultsList }
					</tbody>
				</Table>
				<Loader show={true} priority={10} size="md" opacity={0.5} id="loadmorespinner">Loading...</Loader>
				<input type="hidden" name="nextPageNo" value={this.state.pageNo + 1}/>
 				<input type="hidden" name="moreResults" value="true"/>
 				<input type="hidden" name="scrollID" id="scrollID" value={this.state.searchResultValues.scroll_id}/>
			</div>
		);

	}
}
export default SearchResult;



// WEBPACK FOOTER //
// ./partner/components/searchResult.js